/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { Row, Col } from "react-bootstrap";
import ContactManager from "../../dev/ContactManager";

const AddressDisplay = address => {
  const number = address.number || "";
  const street = address.street ? `${address.street},` : "";
  const suburb = address.suburb || "";
  const postcode = address.postcode || "";
  const state = address.state || "";

  return `${number} ${street} ${suburb} ${postcode} ${state}`.trim();
};

const PresetLocation = props => {
  const { location, locations, errors } = props;
  const hasError = errors.includes("location") ? "has-error" : "";

  const labelClass = errors.includes("location") ? "red-label" : "";
  const locationTypes = [
    { value: "CUSTOMER", label: "Customer" },
    { value: "JOB", label: "Address" }
  ];
  const options = locations.filter(l => l.id !== -1).map(l => ({
    value: l.id,
    label: l.name
  }));
  const handleLocationChange = obj => {
    const loc = props.locations.find(l => l.id === obj.value);
    props.handleChange(loc);
  };
  const address = location.id ? location.address : {};

  return (
    <div className={`preset-location ${hasError}`}>
      <Row style={{ marginBottom: 10 }}>
        <Col sm={3} className="cust-label">
          <label
            className={`location-type-label ${labelClass}`}
            htmlFor="locationType"
          >
            Location Type
          </label>
        </Col>
        <Col sm={9}>
          <Select
            className="job-form-select"
            options={locationTypes}
            value={location.type.code}
            onChange={props.handleLocationTypeChange}
            clearable={false}
          />
        </Col>
      </Row>

      <Row>
        <Col sm={3} className="cust-label">
          <label className={`location-label ${labelClass}`} htmlFor="location">
            Location
          </label>
        </Col>
        <Col sm={9}>
          <Select
            className="job-form-select"
            options={options}
            value={location.id}
            onChange={handleLocationChange}
            clearable={false}
          />
        </Col>
      </Row>

      {location.id ? (
        <div>
          <Row>
            <Col sm={3} />
            <Col sm={9}>
              <div style={{ marginTop: 5 }}>
                <input
                  className="form-control"
                  value={AddressDisplay(address)}
                  readOnly
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={3} />
            <Col sm={9}>
              <ContactManager locationId={location.id} />
            </Col>
          </Row>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
PresetLocation.propTypes = {
  location: PropTypes.object.isRequired,
  locations: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleLocationTypeChange: PropTypes.func.isRequired
};

export default PresetLocation;



// WEBPACK FOOTER //
// ./src/forms/fields/PresetLocation.js